import { confirmDialog } from '@/lib/confirmDialog';
import type { ParteItem } from '../types';

interface ItemConDestino {
  parte: ParteItem;
  monto: number;
  montoBruto?: number;
  destinoPagoId?: string | null;
}

/**
 * Ítems de esas partes que se imprimen en el PDF (importe distinto de cero)
 * y no tienen destino de pago.
 */
export const contarSinDestino = (items: ItemConDestino[], partes: ParteItem[]): number =>
  items.filter(
    (item) =>
      partes.includes(item.parte) && (item.montoBruto ?? item.monto) !== 0 && !item.destinoPagoId
  ).length;

/**
 * Si hay ítems sin destino de pago, pide confirmación antes de exportar o
 * enviar el PDF: esos montos no se suman a ninguna cuenta.
 */
export const confirmarItemsSinDestino = async (
  cantidad: number,
  accion: 'Exportar' | 'Enviar' = 'Exportar'
): Promise<boolean> => {
  if (cantidad === 0) return true;

  return confirmDialog.open({
    title:
      cantidad === 1
        ? `Hay 1 ítem sin destino de pago. ¿${accion} igual?`
        : `Hay ${cantidad} ítems sin destino de pago. ¿${accion} igual?`,
    text: 'En el PDF esos montos no se suman a ninguna cuenta de la forma de pago.',
    confirmButtonText: `${accion} igual`,
  });
};
